import React from 'react';
import { string } from 'prop-types';
import Avatar from 'Modules/Avatar/Avatar';
import styles from './User.less';

const User = (props) => {
  const { image, title, description } = props;
  return (
    <div className={styles.container}>
      <Avatar avatar={image} />
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        <div className={styles.description}>{description}</div>
      </div>
    </div>
  );
};

User.propTypes = {
  image: string.isRequired,
  title: string.isRequired,
  description: string.isRequired,
};

User.defaultProps = {
};

export default User;
